export const ActionTypes = {
    FETCH_CUSTOMERS_LIST: "FETCH_CUSTOMERS_LIST",
    FETCH_ITEMS_LIST: "FETCH_ITEMS_LIST",
    FETCH_INVOICE_LIST: "FETCH_INVOICE_LIST",
};
